import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  SellarImportsPayoutUpdateRequestType,
  SellarImportsPayoutUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../../hooks/useFirebaseUser.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../../../hooks/api/v2/apiV2Request";
import { ServerStateKeys } from "../../../../../hooks/api/v2/ServerStateKeys";

export const useSellarImportPayoutUpdate = (id: number) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SellarImportsPayoutUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `sellar-imports/finance/payouts/${id}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as SellarImportsPayoutUpdateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SellarImportsPayouts,
          id,
        ],
      });
    },
  });
};
